// extracted by mini-css-extract-plugin
export default {"team_release_download":"release_team_release_download__woUe9"};